import './Footer.scss';

const Footer = () => (
  <footer>
    <div className="container text-center">
      <div className="attribution">
        日志数据来自 <a href="https://www.warcraftlogs.com">Warcraft Logs</a>。
        World of Warcraft 及相关素材版权归 Blizzard Entertainment, Inc. 所有。
      </div>
    </div>
  </footer>
);

export default Footer;
